<template>
  <div>
    <b-table
      striped
      hover
      id="orders-table"
      :items="orderList"
      :per-page="perPage"
      :current-page="currentPage"
      :fields="searchFields"
      @row-clicked="item => $set(item, '_showDetails', !item._showDetails)"
      class="mws-table mws-search-results-box"
    >
      <template v-slot:row-details="row">
        <table class="mws-table-row-details" style="float:left; width:50%">
          <tr>
            <td class="mws-col-left"> <b>Part Number</b></td>
            <td class="mws-col-left"> <b>Description</b></td>
            <td class="mws-col-left"> <b>Quantity</b></td>
            <td class="mws-col-left"> <b>Price</b></td>
            <td class="mws-col-left"> <b>Subtotal</b></td>
          </tr>
          <tr
            v-for="(part, partIndex) in row.item.parts" 
            v-bind:key="partIndex"
            class="mb-2"
          > 
            <td class="mws-col-left" style="width:20%;">{{ part.partno }}</td>
            <td class="mws-col-left" style="width:35%">{{ part.description }}</td>
            <td class="mws-col-center" style="width:15%">{{ part.shipped }}</td>
            <td class="mws-col-center" style="width:15%">{{ part.price }}</td>
            <td class="mws-col-center" style="width:15%">{{ part.subtotal }}</td>
          </tr>
          <tr v-if="row.item.error_code != ''" class="mb-2">

            <td style="padding-top:2em !important; color: red !important;"><b>Error condition on order:</b> {{ row.item.error_code }}</td>
          </tr>
        </table>

        <table class="mws-table-row-details" style="float:left">
          <tr>
            <td class="mws-col-left"> <b>Delivery</b></td>
            <td class="mws-col-left"> <b>VAT</b></td>
            <td class="mws-col-left"> <b>Invoice Total</b></td>
            <td class="mws-col-left"> <b>Delivery Label</b></td>
            <td class="mws-col-left"> <b>Invoice</b></td>
          </tr>
          <tr>
            <td valign=”top” class="mws-col-left">{{ row.item.delivery_part }}</td>
            <td valign=”top” class="mws-col-center">{{ row.item.vat_total_value }}</td>
            <td valign=”top” class="mws-col-center">{{ row.item.invoice_total_value }}</td>
            <td valign=”top” v-if="row.item.delivery_label != ''" class="mws-col-center">
              <div>
                <a style="font-weight:700;" :href="row.item.delivery_label" target="_label">
                  View
                </a>
                <a v-if="row.item.remove_label_url !== ''" style="font-weight:700;" :href="row.item.remove_label_url" target="_label">
                  <br/>Remove
                </a>
              </div>
            </td>
            <td v-else valign=”top” class="mws-col-left">
                <dragDrop :key_field="row.item.order_ref"
                          upload_url="/api/savedeliverylabel/"
                          description="Label"
                          div_id="dragDropLabelDiv"
                          form_id="dragDropLabelForm">
              </dragDrop>
            </td>
            <td valign=”top” v-if="row.item.invoice !== ''" class="mws-col-center">
              <div>
                <a style="font-weight:700;" :href="row.item.invoice" target="_label">
                  View
                </a>
                <a v-if="row.item.remove_invoice_url !== ''" style="font-weight:700;" :href="row.item.remove_invoice_url" target="_label">
                  <br/>Remove
                </a>
              </div>
            </td>
            <td v-else valign=”top” class="mws-col-left">
              <dragDrop :key_field="row.item.order_ref"
                        upload_url="/api/saveinvoice/" 
                        description="Invoice" 
                        div_id="dragDropInvoiceDiv"
                        form_id="dragDropInvoiceForm">
              </dragDrop>
            </td>
          </tr>
        </table>
      </template>

      <template class="mws-row-text" v-slot:cell(order_ref)="data" data-html="true">
        <a style="font-weight:700;" :href="`order/${data.item._uid}/`">
          {{ data.value }} 
        </a>
        <span v-if="data.item.error_code !== '' && data.item.error_code !== 0">
          <svg
            xmlns:dc="http://purl.org/dc/elements/1.1/"
            xmlns:cc="http://creativecommons.org/ns#"
            xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
            xmlns:svg="http://www.w3.org/2000/svg"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
            xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
            width="21.522406"
            height="21.509249"
            version="1.1"
            id="svg3725"
            sodipodi:docname="error.svg"
            inkscape:version="0.92.4 (5da689c313, 2019-01-14)">
            <metadata
              id="metadata3731">
              <rdf:RDF>
                <cc:Work
                  rdf:about="">
                  <dc:format>image/svg+xml</dc:format>
                  <dc:type
                    rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
                  <dc:title></dc:title>
                </cc:Work>
              </rdf:RDF>
            </metadata>
            <defs
              id="defs3729" />
            <sodipodi:namedview
              pagecolor="#ffffff"
              bordercolor="#666666"
              borderopacity="1"
              objecttolerance="10"
              gridtolerance="10"
              guidetolerance="10"
              inkscape:pageopacity="0"
              inkscape:pageshadow="2"
              inkscape:window-width="1920"
              inkscape:window-height="1137"
              id="namedview3727"
              showgrid="false"
              inkscape:zoom="5.3888889"
              inkscape:cx="-20.878935"
              inkscape:cy="10.697907"
              inkscape:window-x="1432"
              inkscape:window-y="-8"
              inkscape:window-maximized="1"
              inkscape:current-layer="svg3725"
              inkscape:snap-page="false"
              fit-margin-top="0"
              fit-margin-left="0"
              fit-margin-right="0"
              fit-margin-bottom="0" />
            <path
              d="m 10.640302,0.96732414 a 9.7941591,9.7941589 0 1 0 0.241802,0 z m 0.120925,4.59478826 v 7.0131016 m 0,3.022895 v 0.120876"
              id="path3723"
              style="fill:#ff6600;stroke:#ffffff;stroke-width:1.93464828;stroke-linecap:round"
              inkscape:connector-curvature="0" />
            <path
              style="fill:#ff6600;fill-opacity:0;stroke:#ffff00;stroke-width:0.186;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:0"
              d="m 4.4801273,99.493524 c -25.8088743,-1.85665 -49.7216233,-14.97403 -65.0699053,-35.69422 -8.783273,-11.85742 -14.492606,-25.64307 -16.603723,-40.09105 -0.690893,-4.728306 -0.838197,-6.994802 -0.838197,-12.896906 0,-6.1632894 0.154339,-8.3682564 0.946832,-13.526907 2.211023,-14.392418 7.981843,-28.122751 16.737748,-39.823608 4.798202,-6.412024 11.22755,-12.837992 17.756844,-17.747508 11.865728,-8.922095 26.16834,-14.841243 40.9175247,-16.933752 4.5456406,-0.644903 6.5040886,-0.761906 12.6185563,-0.753866 6.773705,0.0089 9.089908,0.194215 14.960625,1.196919 15.42269,2.634159 29.7825,9.322162 42.19402,19.651628 2.7612,2.298012 8.34058,7.873336 10.60458,10.596888 9.61752,11.569684 15.99736,24.664797 19.07584,39.1546389 1.93285,9.0975967 2.374728,19.7387721 1.20595,29.0412371 -3.26624,25.996266 -17.68241,49.172036 -39.46353,63.442526 -12.87289,8.43401 -27.35595,13.29853 -42.859681,14.39555 -3.095208,0.21901 -9.0569167,0.21335 -12.1834837,-0.0116 z M 15.213848,83.734014 c 12.842534,-0.89284 24.148244,-4.5614 34.790964,-11.28925 7.25398,-4.58563 14.12896,-10.97012 19.31006,-17.93239 15.99621,-21.49542 18.99158,-49.7043474 7.87445,-74.157835 -4.6492,-10.226492 -11.87911,-19.482942 -20.7796,-26.604102 -18.50433,-14.805075 -43.024225,-19.711306 -65.8171064,-13.16947 -24.2954936,6.973103 -43.2755256,26.029598 -50.1492036,50.3512349 -3.688808,13.0523747 -3.657989,26.9833271 0.0886,40.0512221 5.390015,18.80006 18.152141,34.67558 35.434413,44.07882 11.843519,6.44404 26.0716873,9.58777 39.247421,8.67177 z"
              id="path3733"
              inkscape:connector-curvature="0" />
          </svg>

        </span>
      </template>

      <template v-slot:cell(delivery_type_id)="data" data-html="true">
        <div>
          <b-form-select
            v-model="data.item.delivery_type_id"
            @change="saveShippingMethod(data.item._uid, $event)"
            class="mb3"
            :disabled="data.item.is_complete == 1"
          >
            <template slot="first">
              <option :value="0" disabled>Ship by...</option>
            </template>
            <option
              v-for="ship_option in shipping_options"
              v-bind:key="ship_option._uid"
              v-bind:value="ship_option._uid"
            >
              {{ ship_option.name }}
            </option>
          </b-form-select>
        </div>
      </template>
      
      <template v-slot:cell(submit_order_col)="row">
        <b-button :disabled="row.item.is_complete == 1" size="sm" @click="submitOrderClick(row.item, row.index, $event)" class="mr-1 mws-std-button">
          Submit
        </b-button>
      </template>

    </b-table>
    <template>
      <div>
        <b-modal v-b-modal.modal-scrollable hide-footer id="resultMessage" v-model="modalShow" :title="modalTitle">
          <div style="margin: 5px; width:90%">
            {{ modalMessage }}
          </div>
          <b-button style="width:5em; margin-top:1em; margin-left:auto; margin-right:0; display:block;" class="mr-1 mws-std-button" @click="resultMessageOk">OK</b-button>
        </b-modal>
      </div>
    </template>

    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
      aria-controls="orders-table"
      align="center"
      class="mws-pagination"
    ></b-pagination>

    <!--<p class="mt-3">Current Page: {{ currentPage }}</p>-->
  </div>
</template>

<script>
import { apiService } from "../common/api.service";
import dragDrop from "@/components/dragDrop.vue";

export default {
  name: "searchResults",
  props: {
    value: {
      type: Array,
      required: true
    }
  },
    components: {
    dragDrop
  },
  data() {
    return {
      orderList: this.value,
      delivery_statuses: [],
      shipping_options: [],
      perPage: 10,
      currentPage: 1,
      todaysDate: null,
      pastDate: null,
      modalShow: false,
      modalTitle: "",
      modalMessage: "",
      searchFields: [
        { primarykey: "_uid", thClass: "mws-table-header-row", trClass: "mws-table-row", tdClass: "d-none" },
        { key: "order_ref", label: "Reference" },
        { key: "purchase_date_time", label: "Purchased", sortable: true },
        { key: "ship_by_date", label: "Ship by", sortable: true },
        { key: "del_method", label: "Delivery", sortable: true },
        { key: "status", label: "Status" },
        { key: "som_ref", label: "Invoice"},
        { key: "ps_ref", label: "Instruction"},
        { key: "delivery_type_id", label: "Ship via" },
        { key: "submit_order_col", label: "" }
      ]
    };
  },
  computed: {
    rows() {
      if (this.orderList) {
        return this.orderList.length;
      } else {
        return 0;
      }
    }
  },
  methods: {
    submitOrderClick(item, index, event) {
      let method = "POST";
      let endpoint = `/api/submitfordelivery/${item._uid}/1/`;
      apiService(endpoint, method).then(data => {
        console.log(data);
        console.log(typeof data)
        if (typeof(data) === 'undefined')
          this.modalMessage = `Unknown error in response`;
        else if (typeof data === 'string') {
          this.modalMessage = data;
        } else if (typeof data === 'object') {
          if (data.transaction.error==='') {
            this.modalMessage = "Success, say something nice..."
            // Success, so disable the submit button
            document.getElementById(event.currentTarget.id).disabled = true;
          } else {
            this.modalMessage = data.transaction.error
          }
        } else {
          this.modalMessage = `Order submitted successfully `;
          document.getElementById(event.currentTarget.id).disabled = true;
        }
        this.modalShow = true;
        this.modalTitle = `Order ${item.order_ref} submitted`;
      });
    },
    resultMessageOk(bvModalEvt) {
      bvModalEvt
      this.modalShow = false;
    },
    async saveShippingMethod(order_id, $event) {
      if (order_id) {
        let method = "POST";
        let endpoint = `/api/saveshippingmethod/${order_id}/${$event}/`;
        apiService(endpoint, method).then(data => {
          data.results;
                  console.log(data)
        });
      }
    },
    async getShippingMethods() {
      this.shipping_options = [];
      let endpoint = "/api/shippingmethods/";
      await apiService(endpoint).then(data => {
        this.shipping_options = data.results;
      });
    }
  },
  created() {
    this.getShippingMethods();
  }
};
</script>
